import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Zap, Moon } from 'lucide-react';
const triggers = [{
  icon: Brain,
  title: 'CORTISOL ALTO',
  subtitle: '(estrés del día)',
  result: 'Antojo de azúcar y carbohidratos para calmar el sistema nervioso',
  delay: 0.2
}, {
  icon: Zap,
  title: 'GLUCOSA BAJA',
  subtitle: '(horas sin comer)',
  result: 'Antojo de todo lo que de energía rápida e inmediata',
  delay: 0.4
}, {
  icon: Moon,
  title: 'MALA NOCHE',
  subtitle: '(menos de 7 hrs)',
  result: 'Antojo de todo sin control porque la grelina se dispara',
  delay: 0.6
}];
export function MechanismSection() {
  return <section className="py-24 px-4 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-121">
      <div className="absolute inset-0 bg-leaf-pattern opacity-30 pointer-events-none" data-id="element-122" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-124">
          <span className="text-brand-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-125">
            El Mecanismo
          </span>
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-126">
            La Verdad Que Nadie Te Dice
          </h2>
          <p className="text-xl text-brand-cream/80 max-w-3xl mx-auto" data-id="element-127">
            El antojo que sientes a las 3pm no es debilidad. Es una señal
            biológica de tu cuerpo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-128">
          {triggers.map((trigger, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: trigger.delay,
          duration: 0.6
        }} className="bg-brand-medium/20 border border-brand-gold/20 rounded-2xl p-8 backdrop-blur-sm flex flex-col items-center text-center relative overflow-hidden group" data-id="element-129">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-130" />

              <div className="w-16 h-16 rounded-full bg-brand-gold/10 flex items-center justify-center mb-6 text-brand-gold" data-id="element-131">
                <trigger.icon size={32} data-id="element-132" />
              </div>

              <h3 className="text-xl font-bold mb-1 text-brand-lightGold" data-id="element-133">
                {trigger.title}
              </h3>
              <p className="text-sm text-brand-cream/60 mb-6" data-id="element-134">
                {trigger.subtitle}
              </p>

              <div className="w-8 h-8 rounded-full bg-brand-medium/50 flex items-center justify-center mb-6 text-brand-gold" data-id="element-135">
                ↓
              </div>

              <p className="text-brand-cream/90 font-medium leading-relaxed" data-id="element-136">
                {trigger.result}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto space-y-6 text-lg" data-id="element-137">
          <p data-id="element-138">
            Ninguno de estos es un problema de carácter. Son respuestas
            hormonales completamente normales.
          </p>
          <p data-id="element-139">
            El problema es que nadie te enseñó qué comer cuando tu cuerpo manda
            esa señal.
          </p>
          <div className="p-6 border border-brand-gold/30 rounded-xl bg-brand-gold/5 mt-8" data-id="element-140">
            <p className="text-2xl font-heading text-brand-lightGold font-semibold" data-id="element-141">
              Lo que funciona es tener el snack correcto listo en 10 minutos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}